.spinner {
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.visible {
  opacity: 1;
}

/* Opaque only while the LL-HLS startup seek is hidden. During ordinary
   rebuffering the spinner floats over the last decoded frame instead of
   blanking the picture. */
.opaque {
  background: #000;
}

.ring {
  width: 44px;
  height: 44px;
  border: 3px solid rgba(255, 255, 255, 0.15);
  border-top-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
